import React from 'react';

import { useInView } from 'react-intersection-observer';
import { easeInOut, motion } from 'framer-motion';

export default function Animated({ children, referencja, czyZanimowane }) {

    const variants = {
        hidden: { x: '-100%' },
        visible: { x: 0 },
    };

    return (
            <div className="">
                <motion.div
                    initial="hidden"
                    animate={referencja ? 'visible' : 'hidden'}
                    variants={variants}
                    transition={czyZanimowane ?  ({duration: 0.8, ease: 'easeOut'})  :  ({duration: 0.0, ease: 'easeOut'}) }
                    className={czyZanimowane ? 'absolute w-screen h-screen' : ''}
                >
                    {children}
                </motion.div>
            </div>
    );

}